module.exports = __webpack_public_path__ + "static/img/startup.6874941f.png";